/**
 * «Подтип заявки 1» для каждой работы — из спецификации «Работы WO для прода».
 * Данные статичны: /schedules/work_types/ отдаёт только код и название,
 * поэтому подсказки заведены на фронте. У кодов 2000010, 100016 и 100017
 * подтип в спецификации не заполнен — подсказка для них не показывается.
 */

const REPAIR_SUBTYPES = [
  'Нет линка',
  'Низкая скорость',
  'Разрывы',
  'IP-адрес 169…',
  'Работа с кабелем',
  'IP из некорректного диапазона',
  'Перепротяжка',
  'Рост ошибок на порту',
  'Роутер. Не выходит ONLINE',
  'Восстановление 100+',
  'Роутер. Проблема с Wi-Fi',
  'Ошибка 678/769/800/809/868',
  'Другие номерные ошибки',
  'Обращение абонента ТТК',
  'Консультация по ПО',
  'Ремонт линии+IPTV',
  'Ремонт линии+TVE',
  'Не открываются внешние страницы',
  'Ошибка авторизации на Captive-портале',
  'Не открывается Captive-портал',
  'Обращение в офис с технической проблемой',
  'Консультация по Смарт ТВ',
  'TVE. Другие ошибки',
  'TVE. Нет сигнала/черный экран',
  'TVE. Проблема с качеством изображения/звука',
  'TVE. Проблема с подключением к сети',
  'TVE. Замирание картинки/появляется круг загрузки',
  'TVE. Медленное переключение каналов',
  'TVE. Проблема с TVOD/EST',
  'TVE. Проблема с авторизацией',
  'ТВ. Проблема с пультом ДУ',
  'ТВ. Рассыпание/замирание картинки',
  'ТВ. Красный крест',
  'ТВ. Логотип "Билайн" на черном фоне',
  'ТВ. Другие ошибки IPTV',
  'ТВ. Ошибка инициализации клиента',
  'Переключение порта для 100+',
];

const CONNECTION_SUBTYPES = ['Заявка на подключение и любая из:', '1. Конвергенция абонента', '2. Заказ подключения/Дозаказ оборудования'];

export const QUALIFICATION_SUBTYPES: { [code: string]: string[] } = {
  '100001': CONNECTION_SUBTYPES,
  '100002': CONNECTION_SUBTYPES,
  '2000001': ['Информационная ГП. СИ_Обследование B2B On-net'],
  '3000001': ['Заявка на подключение Голден-Телеком'],
  '2000002': ['Информационная ГП. СИ_Установка доп.коммутатора', 'Подключения. Требуется дополнительный коммутатор'],
  '3000006': ['Переключение на Гбит/с'],
  '3000007': REPAIR_SUBTYPES,
  '3000008': REPAIR_SUBTYPES,
  '2000003': ['Аварийная ГП. Авария на оборудовании ДС'],
  '3000002': ['ТВ. Замена приставки техником', 'TVE. Замена приставки техником', 'Замена IPTV на TVE'],
  '3000003': ['Роутер. Замена техническим специалистом', 'Замена роутера'],
  '3000005': ['Дозаказ оборудования', 'Заказ подключения/Дозаказ оборудования'],
  '3000004': ['Роутер. Возврат техническим специалистом', 'Интернет магазин. Возврат оборудования (бесплатно)'],
  '3000009': ['Конвергенция абонента'],
  '2000004': [
    'Аварийная ГП. Устранение замечаний: ДЕЗ,Управа,УК,ГУИС',
    'Информационная ГП. Устранение замечаний: ДЕЗ,Управа,УК,ГУИС',
    'Информационная ГП. Жалоба на оборудование от внешнего клиента',
  ],
  '2000005': ['Информационная ГП. СИ_Массовый срез'],
  '2000006': ['Информационная ГП. СИ_Предоставление доступа к ТКД'],
  '2000007': ['Информационная ГП. СИ_UAT приемочное тестирование'],
  '2000009': ['Информационная ГП. НДД_маркировка ГКС_категория 2, 41-80 эт.площадок'],
  '2000008': ['Информационная ГП. ДРС аудит'],
  '2000011': ['Информационная ГП. НДД Работы с ДРС*'],
  '2000012': ['Информационная ГП. СИ_Телефония_уст_ГШ'],
  '2000013': ['Информационная ГП. СИ_Телефония_переключение'],
  '2000014': ['Информационная ГП. СИ_телефония off-net'],
  '2000015': ['Информационная ГП. СИ_телефония ремонт'],
  '2000016': ['Информационная ГП. СИ_Предпротяжка кабеля'],
  '2000017': ['Информационная ГП. СИ_Замена коммутатора'],
  '3000010': ['Настройка ТВ при переезде'],
  '3000011': ['Мониторинг'],
  '3000012': ['Мониторинг'],
  '2000018': ['Информационная ГП. НДД_маркировка ГКС_категория 0, дома без ДРС ШПД'],
  '2000019': ['Информационная ГП. НДД_маркировка ГКС_категория 1, <= 40 эт. площадок'],
  '2000020': ['Информационная ГП. НДД_маркировка ГКС_категория 3, > 80 эт. площадок'],
  '3000013': ['Замена устаревшей приставки TVE (ZTE)'],
};
